module.exports = __webpack_public_path__ + "static/media/accounts-registration.466e5f57.jpg";